import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import PlatformSideNav from '@nextiva/platform-modules__side-nav';

import CallDistribution from 'containers/CallDistribution/CallDistribution';
import Voicemail from 'containers/VoiceMail/Voicemail';
import { CallForwarding } from 'containers/CallForwarding';
import { TeamPhoneNumberContainer } from 'containers/TeamPhoneNumber';

import {
  TEAMS_CALL_GROUP,
  TEAMS_CALL_GROUP_PHONE_NUMBER,
  TEAMS_CALL_GROUP_CALL_DISTRIBUTION,
  TEAMS_CALL_GROUP_VOICEMAIL,
  TEAMS_CALL_GROUP_FORWARDING,
} from 'constants/routes';

const TeamCallGroup = ({ history, match, user }) => {
  const huntGroupId = match.params.groupId;
  const isHipaa = user.data?.accountInfo?.hipaa || false;

  return (
    <div className="m-team-call-group">
      <div
        className="m-team-call-group__side-nav"
        data-testid="PlatformAdminUI-TeamVoiceSettings-TeamCallGroup-SideNav"
      >
        <PlatformSideNav
          history={history}
          match={match}
          params={match.params}
        />
      </div>
      <div
        className="m-team-call-group__routes"
        data-testid="PlatformAdminUI-TeamVoiceSettings-TeamCallGroup-CallGroupRoutes"
      >
        <Switch>
          <Route exact path={[TEAMS_CALL_GROUP, TEAMS_CALL_GROUP_PHONE_NUMBER]}>
            <TeamPhoneNumberContainer huntGroupId={huntGroupId} />
          </Route>
          <Route exact path={TEAMS_CALL_GROUP_CALL_DISTRIBUTION}>
            <CallDistribution huntGroupId={huntGroupId} />
          </Route>
          <Route exact path={TEAMS_CALL_GROUP_VOICEMAIL}>
            <Voicemail huntGroupId={huntGroupId} isHipaaEnabled={isHipaa} />
          </Route>
          <Route exact path={TEAMS_CALL_GROUP_FORWARDING}>
            <CallForwarding huntGroupId={huntGroupId} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

TeamCallGroup.propTypes = {
  user: PropTypes.object,
};
TeamCallGroup.defaultProps = {
  user: {},
};

const mapStateToProps = (state) => ({
  user: state['__global/user'],
});

export default connect(mapStateToProps)(TeamCallGroup);
